import React from 'react';
import { SpacerSectionStoryblok } from '../../types/storyblok';
import { Box } from '../../base/Box/Box';
import classNames from 'classnames';

export const SpacerSection = ({
  smHeight = '0',
  mdHeight = '0',
  lgHeight = '0',
  colourScheme = 'white',
  overlayOverBkg,
}: SpacerSectionStoryblok) => {
  if (!smHeight && !mdHeight && !lgHeight) {
    return null;
  }
  return (
    <Box
      as="section"
      colourScheme={colourScheme}
      bkg
      className={classNames(
        smHeight && smHeight !== '0' && `h-${smHeight}`,
        mdHeight && mdHeight !== '0' && `md:h-${mdHeight}`,
        lgHeight && lgHeight !== '0' && `lg:h-${lgHeight}`
      )}
      spacer
      overlayOverBkg={overlayOverBkg}
    >
      {/* Spacer */}
    </Box>
  );
};

export default SpacerSection;
